import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppState } from '../store/app.reducer';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard  {
  constructor(private router: Router){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const store: AppState = localStorage.getItem('appState') ? JSON.parse(atob(localStorage.getItem('appState') || '')) : null;
    if (!store) return false;
    const { auth } = store;
		if (auth && auth.user) {
			this.router.navigate(['/admin']);
		}
    return true;
  }
}
